// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox_checkbox__LSWy-","input":"checkbox_input__1MMKj","text":"checkbox_text__3Kba-","error":"checkbox_error__1EwUt"};